import { ItiHttpService } from "@/iti-core-react/services/iti-http-service";
import { API } from "../api";
import {
	DatabaseConnectionFormData,
	POSTGRESQLSourceDataConfigurationDto,
	StreamingConnectorRequest,
	StreamingConnectorResponse,
} from "../dtos/database-dto";

export interface StreamingError {
	statusMessage?: string;
	[key: string]: any;
}

export interface StreamingDto {
	streamingId?: string;
	sessionId?: string;
	status: {
		code: string;
		description?: string;
	};
	executionErrors?: StreamingError[];
	[key: string]: any;
}

export const StreamingService = {
	async getStreamingStatus(
		streamingId: string,
		showLoading = false,
	): Promise<StreamingDto> {
		return await ItiHttpService.get(
			`${API.streaming.base}/${streamingId}`,
			{},
			showLoading,
		);
	},
	async createConnector(
		data: StreamingConnectorRequest,
		showLoading = true,
	): Promise<StreamingConnectorResponse> {
		const res = await ItiHttpService.post(
			API.streaming.connector,
			data,
			showLoading,
		);
		return res;
	},

	mapFormDataToRequest(
		formData: DatabaseConnectionFormData,
		datasetId: string,
		datasetName?: string,
	): StreamingConnectorRequest {
		const sourceConfiguration: POSTGRESQLSourceDataConfigurationDto = {
			sourceType: "POSTGRESQL",
			url: formData.host,
			port: Number.parseInt(formData.port, 10),
			user: formData.username,
			password: formData.password,
			database: formData.database,
			schema: formData.schema,
		};

		return {
			sessionName: formData.connectionName,
			sessionDescription:
				formData.connectionDescription || formData.connectionName,
			datasetId: datasetId,
			datasetName: datasetName || formData.connectionName,
			sourceConfiguration: sourceConfiguration,
			startNow: true,
		};
	},

	async createConnectorFromForm(
		formData: DatabaseConnectionFormData,
		datasetId: string,
		datasetName?: string,
		showLoading = true,
	): Promise<StreamingConnectorResponse> {
		const request = this.mapFormDataToRequest(formData, datasetId, datasetName);
		return this.createConnector(request, showLoading);
	},
};
